import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import type { NavItem } from '@claim-os/shared';

// New Claim / New GAP Request now live in the sidebar's "New" CTA menu
export const NAV_ITEMS: NavItem[] = [
  { to: '/claims', label: 'Claims', icon: AssignmentOutlinedIcon },
  { to: '/uploads', label: 'EOBs & Correspondences', icon: CloudUploadOutlinedIcon },
  { to: '/powerbi-reports', label: 'PowerBI Reports', icon: BarChartOutlinedIcon },
];
